import { render, staticRenderFns } from "./PublishingProjectsEdit.vue?vue&type=template&id=fedc29e0&scoped=true"
import script from "./PublishingProjectsEdit.vue?vue&type=script&lang=js"
export * from "./PublishingProjectsEdit.vue?vue&type=script&lang=js"
import style0 from "./PublishingProjectsEdit.vue?vue&type=style&index=0&id=fedc29e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedc29e0",
  null
  
)

export default component.exports